'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request(origin, algo, files) {
  this.BV = null;
  this.Jg = null;
  this.Jh = null;
  this.BV = origin;
  this.Jg = algo;
  this.Jh = files;
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request as $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request as $h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request };
$h_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request)) {
    if (((this.BV === x$0.BV) && (this.Jg === x$0.Jg))) {
      var x = this.Jh;
      var x$2 = x$0.Jh;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "LocalPjeOfficeSignFileBase64Request";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.BV;
      break;
    }
    case 1: {
      return this.Jg;
      break;
    }
    case 2: {
      return this.Jh;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.pm = (function() {
  return this.BV;
});
function $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hB)));
}
export { $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request as $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request };
var $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request, "presto.AgentView$LocalPjeOfficeSignFileBase64Request", ({
  hB: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request as $d_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-File-Base64-Request.js.map
